import { useEffect } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplateSearchPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src";
import { experiments, useExperimentExposure } from "@/utils/experiment";

export type ConfluenceTemplateCategoryPageProps = {
    templates?: Template[];
    partnerTemplates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
};

export const ConfluenceTemplateSearchPage = ({
    templates,
    partnerTemplates,
    collections,
    categories
}: ConfluenceTemplateCategoryPageProps) => {
    const [relayExposureFired, fireRelayExposure] = useExperimentExposure(
        experiments.gwpAddRelayToConfluenceTemplatesLanding
    );

    useEffect(() => {
        if (!relayExposureFired) {
            fireRelayExposure();
        }
    }, [relayExposureFired, fireRelayExposure]);

    return (
        <ConfluenceTemplateSearchPageTemplate
            templates={templates}
            partnerTemplates={partnerTemplates}
            collections={collections}
            categories={categories}
        />
    );
};
